import React, {ChangeEvent} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {HighlightOff, PictureAsPdf, PlusOne} from "@mui/icons-material";
import {IconButton, Typography} from "@mui/material";
import FileService from "../../services/file.service";
import Grid from "@mui/material/Grid";
import {setErrorMessage} from "../../store/reducers/message";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store";
import {FileMetadata, FileMetadataTypeEnum} from "../../gen/api";
import TableViewIcon from '@mui/icons-material/TableView';
import UploadIcon from '@mui/icons-material/Upload';

type Props = {
  fileType: FileMetadataTypeEnum
  handleNewFormSubmit: (metadata: FileMetadata) => void
}

function FileUpload({fileType, handleNewFormSubmit}: Props) {
  const [formName, setFormName] = React.useState<String>();
  const [file, setFile] = React.useState<File>();
  const dispatch = useDispatch<AppDispatch>();
  const fiveMb = 5242880;
  const pdfFileType = "application/pdf";
  const oldExcelFileType = "application/vnd.ms-excel";
  const currentExcelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  function setFormFile(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files && event.target.files?.length > 0) {
      const currentFile = event.target.files[0];

      // Validate file size and file type
      if (currentFile.size > fiveMb) {
        dispatch(setErrorMessage("Die Datei darf max. 5MB groß sein."));
        return;
      } else if (fileType === FileMetadataTypeEnum.Form && currentFile.type !== pdfFileType) {
        dispatch(setErrorMessage("Bitte wählen Sie eine PDF Datei aus."));
        return;
      } else if (fileType === FileMetadataTypeEnum.EvaluationRoutine && currentFile.type !== oldExcelFileType && currentFile.type !== currentExcelFileType) {
        dispatch(setErrorMessage("Bitte wählen Sie eine Excel Datei aus."));
        return;
      }

      setFile(currentFile);
    }
  }

  function uploadForm() {
    if (!file) return;
    const metaData = {name: formName, fileName: file.name, type: fileType} as FileMetadata;
    FileService.uploadFile(metaData, file).then(savedForm => {
      handleNewFormSubmit(savedForm);
      setFile(undefined);
      setFormName(undefined);
    }).catch(_ =>
      dispatch(setErrorMessage("Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es später erneut."))
    )
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={3} alignSelf="flex-end">
          <Typography>Neue Datei hochladen:</Typography>
        </Grid>
        <Grid item xs={3}>
          <TextField id="download-text" label="Name" variant="standard" required={true}
                     value={formName || ""}
                     onChange={event => setFormName(event.target.value)} />
        </Grid>
        <Grid item xs={3} alignSelf="flex-end">
          {!file &&
			  <Button variant="contained" component="label"
					  startIcon={fileType === FileMetadataTypeEnum.Form ? <PictureAsPdf /> :
                        <TableViewIcon />}>
				  Datei auswählen (max. 5MB)
				  <input hidden
						 accept={fileType === FileMetadataTypeEnum.Form ? pdfFileType : `${oldExcelFileType}, ${currentExcelFileType}`}
						 type="file" onChange={setFormFile} />
			  </Button>}
          {file &&
			  <>
				  <Typography>{file.name}
					  <IconButton onClick={() => setFile(undefined)}
								  edge="end"><HighlightOff /></IconButton>
				  </Typography>
			  </>
          }
        </Grid>
        <Grid item xs={3} textAlign="end" alignSelf="flex-end">
          <IconButton onClick={uploadForm} disabled={!file || !formName}>
            <PlusOne />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}

export default FileUpload;